import React, { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import WebForm from "./webform";
import BenifForm from "./benif";
import ReviewForm from "./review";
import HeaderComponent from "./header";
import ProgressBar from "./ProgressBar";
import Attachments from "./attachments";
import { useFormContext } from "react-hook-form";
// import "../styles/SwipeForm.css";

const SwipeForm = () => {
  

  const { watch } = useFormContext();
  const damage = watch("damage");
  const methods = useForm({
    defaultValues: {
      damage: damage,
      firstName: "",
      secondName: "",
      thirdName: "",
      fourthName: "",
      surname: "",
      motherName: "",
      MotherName2: "",
      MotherName3: "",
      birthdate: "",
      sex: "",
      socialStatus: "",
      province: "",
      court: "",
      muhalla: "",
      street: "",
      dar: "",
      isPreviousAddressSame: false,
      previousProvince: "",
      previousCourt: "",
      previousMuhalla: "",
      previousStreet: "",
      previousDar: "",
      ministry: "",
      placeOfIncident: "",
      incidentDate: "",
      numberOfWives: "",
      district: "",
      profession: "",
      phone1: "",
      phone2: "",
      phone3: "",
      notes: "",
      familyMembers: [],
      front_id: null,
      back_id: null,
      residence_card: null,
      isParentAlive: "1",
      isMartyerStopped: "0",
      isLand: "0",
      isAppartment: "0",
      isCash1: "0",
      isSalary: "0",
      lastInjuryPercentage: "0",
      isWife: "0",
      appName: "",
      appLink: "",
      state: 1,
    }
  });

  const stepLabelsDamage1 = [
    'معلومات الشهيد',     // Step 1: WebForm
    'معلومات زوج/زوجة الشهيد',   // Step 2: BenifForm
    'إرفاق المستندات المطلوبة',   // Step 3: Attachments
    'مراجعة وإرسال'       // Step 4: ReviewForm
  ];
  
  const stepLabelsNoDamage = [
    'معلومات الجريح',     // Step 1: WebForm
    'إرفاق المستندات المطلوبة',   // Step 2: Attachments
    'مراجعة وإرسال'       // Step 3: ReviewForm
  ];

  

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState(methods.getValues()); // Store form data

  const handleNext = () => {
    setFormData(methods.getValues()); // Update formData with current values
    setStep(step + 1);
  };
  const handlePrevious = () => setStep(step - 1);

  const handleSubmit = () => {
    console.log("Form submitted:", formData);
  };

  return (
    <FormProvider {...methods}>
      <div className="form-wrapper">
        <div className={`form-content step-${step}`}>

          {step === 1 && <HeaderComponent />}
          
          {damage === 1 ? (
            <div>
              <ProgressBar steps={step} setStep={setStep} stepLabels={stepLabelsDamage1} />
              {step === 1 && <WebForm onNext={handleNext} />}
              {step === 2 && <BenifForm onNext={handleNext} onPrevious={handlePrevious} />}
              {step === 3 && <Attachments onNext={handleNext} onPrevious={handlePrevious} />}
              {step === 4 && <ReviewForm onPrevious={handlePrevious} onSubmit={handleSubmit} />}
            </div>
          ) : (
            <div>
              <ProgressBar steps={step} setStep={setStep} stepLabels={stepLabelsNoDamage} />
              {step === 1 && <WebForm onNext={handleNext} />}
              {step === 2 && <Attachments onNext={handleNext} onPrevious={handlePrevious} />}
              {step === 3 && <ReviewForm onPrevious={handlePrevious} onSubmit={handleSubmit} />}
            </div>
          )}
        </div>
      </div>
    </FormProvider>
  );
};

export default SwipeForm;
